module.exports = __webpack_public_path__ + "static/media/jobImg2.15bdbb29.jpg";